<template>
  <table class="responsive-table">
    <thead>
      <tr>
        <th v-for="(header, index) in headers" :key="index">{{ header }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
        <td v-for="(cell, cellIndex) in row" :key="cellIndex" :data-label="headers[cellIndex]">
          <span>{{ cell }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
defineProps<{
  headers: string[]
  rows: (string | number)[][]
}>()
</script>

<style lang="scss" scoped>
.responsive-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th {
    text-align: left;
    font-weight: 600;
  }

  th,
  td {
    padding-block: 12px;
    border-bottom: 1px solid $grey-50;
  }

  @include mobile {
    thead {
      display: none;
    }

    tr {
      display: block;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    td {
      display: flex;
      gap: 16px;
      text-align: left;
      border-bottom: 1px solid $grey-50;
      padding-block: 12px;

      &::before {
        content: attr(data-label);
        font-weight: 600;
        flex: 1;
      }

      span {
        flex: 1;
      }
    }
  }
}
</style>
